import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import New from "screens/new/component";
import Application from "screens/application/component";
import SecretPdfView from "screens/secret-pdf/component/view";
import TermsAndConditions from "screens/terms-and-conditions/component";
import PrivacyPolicy from "screens/privacy-policy/component";
import Activations from "screens/activations/component";
import AnnouncementsView from "screens/announcements/component/view";
import Memberships from "screens/memberships/component";
import Events from "screens/events/component/event";
import Nomination from "screens/events/component/nomination";
import { Invitation } from "screens/invitation/component/invitation";
import { SharedEvent } from "screens/shared-event/component";
import { LiveEventDetails } from "screens/events/component/live-event-details";
import AccountDeletionPolicy from "./screens/account-deletion-policy/component";
import PartnerTermsNeueHouse from "./screens/partner-terms/component/neuehouse";
import ShareNomination from "./screens/events/component/share-nomination";

const Router = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/" exact component={New} />
      <Route
        path="/announcements/:id?/:name?"
        exact
        component={AnnouncementsView}
      />
      <Route
        path="/application/:currentStep?/:urlUserId?/:urlEmailId?"
        exact
        component={Application}
      />
      <Route path="/membership-pdf" exact component={SecretPdfView} />
      <Route
        path="/account-deletion-policy"
        exact
        component={AccountDeletionPolicy}
      />
      <Route path="/privacy-policy" exact component={PrivacyPolicy} />
      <Route path="/refer-a-friend/:hash" exact component={Invitation} />
      <Route path="/select-membership" exact component={Memberships} />
      <Route path="/share/:hash" exact component={SharedEvent} />
      <Route
        path="/share/:hash/share-nomination"
        exact
        component={ShareNomination}
      />
      <Route path="/share/:hash/event" exact component={Events} />
      <Route
        path="/share/:hash/event/details"
        exact
        component={LiveEventDetails}
      />
      <Route path="/share/:hash/nomination" exact component={Nomination} />
      <Route
        path="/terms-and-conditions"
        exact
        component={TermsAndConditions}
      />

      <Route path="/activations" component={Activations} />
      <Route path="/announcements" component={Activations} />
      <Route path="/apphome" component={Activations} />
      <Route path="/application" component={Activations} />
      <Route path="/chat" component={Activations} />
      <Route path="/community" component={Activations} />
      <Route path="/home" component={Activations} />
      <Route path="/members" component={Activations} />
      <Route path="/refer-friend" component={Activations} />
      <Route path="/select-membership" component={Activations} />
      <Route path="/suggest-event" component={Activations} />
      <Route path="/waitlist" component={Activations} />
      <Route path="/terms/neuehouse" component={PartnerTermsNeueHouse} />
    </Switch>
  </BrowserRouter>
);

export default Router;
